import type { LocationModel } from '@VelocitySquared/cady-sunny16-commerce-integration-models'

type LocationAddressFields = Pick<LocationModel, 'Address1' | 'City' | 'State' | 'Zip'>

/** Format a location's full street address: "Address1, City, State Zip" */
export function formatLocationFullAddress(location: LocationAddressFields): string {
  return `${location.Address1}, ${location.City}, ${location.State} ${location.Zip}`
}

/** Format a location's city line: "City, State Zip" */
export function formatLocationCityLine(location: LocationAddressFields): string {
  return `${location.City}, ${location.State} ${location.Zip}`
}
